import { CSSProperties } from 'react'
import { colours } from '@headbox-ui/themes'

const { black, brick } = colours

export const s = {
  wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  } as CSSProperties,
  root: {
    maxWidth: 650,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    gap: 28,
  } as CSSProperties,
  header: {
    root: { marginBottom: 0, color: black } as CSSProperties,
    smartBook: {
      color: brick[600],
    } as CSSProperties,
  },
  buttons: {
    root: {
      display: 'flex',
      gap: 12,
    } as CSSProperties,
    buttons: {
      backgroundColor: 'transparent',
      fontWeight: 600,
      borderColor: '#595959',
      background: 'transparent',
    } as CSSProperties,
  },
}
